import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import {  NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthService } from './core/authentication/auth.service';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { ExternalUiSharedModule } from './external-ui-shared/external-ui-shared.module';
import { UiNotificationService } from './external-ui-shared/services/ui-notification.service';
import { HeaderComponent } from './headers/header.component';
import { TechnicianCenterHeaderComponent } from './headers/technician-center-header/technician-center-header.component';
import { AyLoginComponent } from './login/ay-login.component';
import { SharedModule } from './shared/shared.module';
import { gridReducer } from './shared/state/grid/grid.reducer';
import { MobileCenterHeaderComponent } from './headers/mobile-center-header/mobile-center-header.component';
import { WorkshopCenterHeaderComponent } from './headers/workshop-center-header/workshop-center-header.component';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import localePl from '@angular/common/locales/pl';
import localeDe from '@angular/common/locales/de';
import localePt from '@angular/common/locales/pt';
import "@progress/kendo-angular-intl/locales/it/all";
import "@progress/kendo-angular-intl/locales/en/all";
import "@progress/kendo-angular-intl/locales/pl/all";
import "@progress/kendo-angular-intl/locales/de/all";
import "@progress/kendo-angular-intl/locales/pt/all";
import { LocaleProvider } from './core/providers/localeProvider';
import { ICON_SETTINGS, IconSettingsService } from '@progress/kendo-angular-icons';
import { PortalSwitcherComponent } from './headers/portal-switcher/portal-switcher.component';
import { PortalMessageModule } from './feature-module/message/portal-message.module';
import { DealerCenterHeaderComponent } from './headers/dealer-center-header/dealer-center-header.component';
import { CalculatorCenterHeaderComponent } from './headers/calculator-center-header/calculator-center-header.component';
import { CalculationWebCenterHeaderComponent } from './headers/calculation-web-center-header/calculation-web-center-header.component';
import { PartsSupplierCenterHeaderComponent } from './headers/parts-supplier-center-header/parts-supplier-center-header.component';

registerLocaleData(localeIt);
registerLocaleData(localePl);
registerLocaleData(localeDe);
registerLocaleData(localePt);
// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    AyLoginComponent,
    HeaderComponent,
    TechnicianCenterHeaderComponent,
    MobileCenterHeaderComponent,
    WorkshopCenterHeaderComponent,
    PortalSwitcherComponent,
    DealerCenterHeaderComponent,
    CalculatorCenterHeaderComponent,
    CalculationWebCenterHeaderComponent,
    PartsSupplierCenterHeaderComponent,
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    SharedModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ExternalUiSharedModule,
    PortalMessageModule,
    StoreModule.forRoot({ gridState: gridReducer }),
    StoreDevtoolsModule.instrument(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: translateLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
      deps: [AuthService, UiNotificationService],
    },
    LocaleProvider,
    //  { provide: HTTP_INTERCEPTORS, useClass: ServerErrorInterceptor, multi: true,   },
    //{ provide: LOCALE_ID, useValue: "it-IT" },
    IconSettingsService,
    {
      provide: ICON_SETTINGS,
      useValue: {
        type: "font",
        size: "large",
      },
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}


export function translateLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, "./assets/i18n/", ".json");
}
